"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageBoardBackground = PageBoardBackground;
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const getRandomBoardState_1 = require("~/utils/getRandomBoardState");
const ThemedBoard_1 = require("./game/board/ThemedBoard");
const piece_1 = require("./game/board/piece");
const useBackgroundStyles = (0, react_jss_1.createUseStyles)({
    root: {
        "position": "absolute",
        "height": "200%",
        "top": "-25%",
        "left": "-25%",
        "aspectRatio": "1 / 1",
        "zIndex": -1,
        "transform": "rotate(-11deg)",
        "filter": "saturate(1.2) blur(2px)",
        // todo rework to use aspect ratio queries
        "@media (orientation: landscape)": {
            width: "140%",
            height: "auto",
        },
        "@media (orientation: portrait)": {
            height: "140%",
            width: "auto",
        },
        // support for large portrait screens e.g. iPad Pro
        "@media (orientation: portrait) and (min-width: 720px)": {
            height: "180%",
            width: "auto",
            transform: "rotate(-17deg)",
        },
    },
    segment: {
        position: "absolute",
        width: "50%",
        height: "50%",
    },
});
const makeRenderItem = (pieces) => (pieceId) => {
    const piece = pieces[pieceId];
    return {
        item: piece ? (react_1.default.createElement(piece_1.Piece, { piece: piece, healthbar: {
                color: piece.ownerId === "home" ? "friendly" : "enemy",
                current: piece.maxHealth,
            } })) : null,
        draggable: false,
    };
};
function PageBoardBackground() {
    const classes = useBackgroundStyles();
    const state1 = react_1.default.useMemo(() => (0, getRandomBoardState_1.getRandomBoardState)("1", 6), []);
    const render1 = react_1.default.useMemo(() => makeRenderItem(state1.pieces), [state1]);
    const state2 = react_1.default.useMemo(() => (0, getRandomBoardState_1.getRandomBoardState)("2", 6), []);
    const render2 = react_1.default.useMemo(() => makeRenderItem(state2.pieces), [state2]);
    const state3 = react_1.default.useMemo(() => (0, getRandomBoardState_1.getRandomBoardState)("3", 6), []);
    const render3 = react_1.default.useMemo(() => makeRenderItem(state3.pieces), [state3]);
    const state4 = react_1.default.useMemo(() => (0, getRandomBoardState_1.getRandomBoardState)("4", 6), []);
    const render4 = react_1.default.useMemo(() => makeRenderItem(state4.pieces), [state4]);
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement("div", { className: classes.segment, style: { top: 0, left: 0 } },
            react_1.default.createElement(ThemedBoard_1.ThemedBoard, { state: state1.board, renderItem: render1, dragDrop: false })),
        react_1.default.createElement("div", { className: classes.segment, style: { top: 0, right: 0 } },
            react_1.default.createElement(ThemedBoard_1.ThemedBoard, { state: state2.board, renderItem: render2, dragDrop: false })),
        react_1.default.createElement("div", { className: classes.segment, style: { bottom: 0, left: 0 } },
            react_1.default.createElement(ThemedBoard_1.ThemedBoard, { state: state3.board, renderItem: render3, dragDrop: false })),
        react_1.default.createElement("div", { className: classes.segment, style: { bottom: 0, right: 0 } },
            react_1.default.createElement(ThemedBoard_1.ThemedBoard, { state: state4.board, renderItem: render4, dragDrop: false }))));
}
